export default "__VITE_ASSET__BfuxmQvn__"